<template>
  <div :class="['rounded-md p-4', variantClasses]" role="alert">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const VARIANT_CLASSES = {
  success: 'bg-green-50 border border-green-200 text-green-800',
  error: 'bg-destructive/10 border border-destructive/20 text-destructive',
  warning: 'bg-amber-50 border border-amber-200 text-amber-700',
  info: 'bg-primary/10 border border-primary/20 text-primary',
}

const props = defineProps({
  variant: {
    type: String,
    default: 'info',
    validator: (value) => ['success', 'error', 'warning', 'info'].includes(value),
  },
})

const variantClasses = computed(() => VARIANT_CLASSES[props.variant])
</script>
